import { ForwardedRef, forwardRef } from "react";
import { FieldPath, FieldValues } from "react-hook-form";
import { Input, InputProps } from "../forms/input";
import { FormField, TFormField } from "./form-field";

export type InputFormFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = TFormField<TFieldValues, TFieldPath> & Omit<InputProps, "children">;

export const InputFormField = forwardRef(function InputFormField<
  TFieldValues extends FieldValues = FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: InputFormFieldProps<TFieldValues, TFieldPath>,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return (
    <FormField {...props}>
      {(field) => <Input ref={ref} {...props} {...field} />}
    </FormField>
  );
});
